import React from 'react';
import ErrorBoundary from '../ErrorBoundary';
// import ImportInbox from '../importInbox';
import Inbox from '../ImportInbox';

export default function ScreenInboxImport() {
  return (
    <ErrorBoundary>
      <Inbox />
    </ErrorBoundary>
  );
}
